import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import get from 'lodash/get'
import Icon from 'discada/dist/Icon'

import { updateQuote } from 'actions/quoteActions'
import { SimpleSelectField } from 'discada/dist/Form'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { getRooftopWebsite } from 'selectors/appStatusSelectors'

import { TP_PARTNER_ID } from 'utils'

import './TradePendingSearch.scss'

const TP = window.SNAP,
  DETAILS_URL = 'https://snap-api.tradepending.com/api/v4/select/details',
  getYMMT = trade => {
    let fields = ['year', 'make', 'model', 'trim']

    return fields
      .map(f => get(trade, f))
      .filter(x => x)
      .join(' ')
  }

export class TradePendingSearch extends React.Component {
  setupTradePending() {
    let { tradeKey } = this.props

    TP &&
      TP.configure_with_options(
        {
          css_selector: `.trade-input-${tradeKey} input.trade-pending`,
          partner_id: TP_PARTNER_ID,
        },
        this.onTPVehicleChange.bind(this),
      )
  }

  componentDidMount() {
    this.setupTradePending()
  }

  updateTP(key, attrs, also = {}) {
    let { tradeIndex, vehicleId, quoteId, updateQuote } = this.props,
      tradeKey = `trades[${tradeIndex}]`,
      tpKey = `${tradeKey}.tradePending.${key}`

    updateQuote(vehicleId, quoteId, {
      [tpKey]: attrs,
      ...also,
    })
  }

  onTPVehicleChange(_, tpVehicle = {}) {
    let also = Object.keys(tpVehicle).reduce(
      (ret, k) => ({
        ...ret,
        [`trades.${this.props.tradeIndex}.${k}`]: tpVehicle[k],
      }),
      {},
    )

    this.updateTP('vehicle', tpVehicle, also)
    this.getTradeChoices(tpVehicle)
  }

  getTradeChoices(tpVehicle) {
    let { dealerWebsite } = this.props,
      { year, make, model, trim } = tpVehicle

    axios
      .get(DETAILS_URL, {
        params: {
          year,
          make,
          model,
          trim,
          dealer_url: dealerWebsite,
          partner_id: TP_PARTNER_ID,
        },
      })
      .then(r => {
        this.updateTP('choices', get(r, 'data.details', []), {
          [`trades.${this.props.tradeIndex}.tradePending.vehicle`]: get(
            r,
            'data.details[0]',
          ),
        })
      })
  }

  render() {
    let { tpData, trade } = this.props,
      { vehicle = {}, choices = [], report = {} } = tpData

    return (
      <div className="tradepending-search">
        <div className="search-wrapper">
          <Icon icon="chevron-double-right" />
          <input
            type="text"
            className="trade-pending"
            placeholder="What Year, Make, Model is your trade?"
            defaultValue={
              get(report, 'ymmt') || get(trade, 'ymmt') || getYMMT(trade)
            }
          />
        </div>
        {choices.length > 1 && (
          <SimpleSelectField
            size="small"
            value={vehicle.id}
            onChange={({ target }) => {
              this.updateTP('vehicle', choices.find(d => d.id === target.value))
            }}
            options={choices.reduce(
              (ret, d) => ({
                ...ret,
                [d.id]: `${d.drivetrain} ${d.engine} ${d.fuel_type} ${d.doors} door ${d.body}`,
              }),
              {},
            )}
          />
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let trade = getQuoteValue(
    state,
    op.vehicleId,
    op.quoteId,
    `trades[${op.tradeIndex}]`,
    {},
  )

  return {
    ...op,
    trade,
    tpData: get(trade, 'tradePending', {}),
    dealerWebsite: getRooftopWebsite(state),
  }
}

export default connect(
  mapStateToProps,
  { updateQuote },
)(TradePendingSearch)
